/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-24 14:31:53
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-02 17:39:33
 * @FilePath: /unifyxp-v2-store-portal/src/request/category/index.ts
 */
import { get, post, remove } from 'src/tools/server';

const getCategories = (uuid?: string) => {
  return get(`/portal/salesChannel/${uuid}/category/products`, {});
};

const postMoveProducts = (body: any) => {
  return post(`/portal/salesChannel/category/products/moveProducts`, body, {});
};

const postGetOptions = (body: any, options = {}) => {
  return post(
    `/portal/salesChannel/category/products/getOptions`,
    body,
    options,
  );
};

const postCategoryProduct = (body, options) => {
  return post(`/portal/salesChannel/category/products`, body, options);
};

const postCategoryProductsMove = (body, options?) => {
  return post(
    `/portal/salesChannel/category/products/moveProducts`,
    body,
    options || {},
  );
};

const postCategoryProductsSearch = (body, options?) => {
  return post(
    `/portal/salesChannel/category/products/search`,
    body,
    options || {},
  );
};

const deleteCategory = (uuid) => {
  return remove(`/portal/salesChannel/category/${uuid}/products`, {});
};
//===legal=====
const getLegalCategories = (uuid?: string) => {
  return get(`/portal/salesChannel/${uuid}/category/legal`, {});
};

const postGetLegalOptions = (body: any, options = {}) => {
  return post(`/portal/salesChannel/category/legal/getOptions`, body, options);
};

const postCategoryLegal = (body, options) => {
  return post(`/portal/salesChannel/category/legal`, body, options);
};

const postCategoryLegalSearch = (body, options?) => {
  return post(
    `/portal/salesChannel/category/legal/search`,
    body,
    options || {},
  );
};
//====content==========
const getContentCategories = (uuid?: string) => {
  return get(`/portal/salesChannel/${uuid}/category/content`, {});
};

const postGetContentOptions = (body: any, options = {}) => {
  return post(
    `/portal/salesChannel/category/content/getOptions`,
    body,
    options,
  );
};

const postCategoryContent = (body, options) => {
  return post(`/portal/salesChannel/category/content`, body, options);
};

const postCategoryContentSearch = (body, options?) => {
  return post(
    `/portal/salesChannel/category/content/search`,
    body,
    options || {},
  );
};

export {
  postCategoryProductsMove,
  getCategories,
  postMoveProducts,
  postGetOptions,
  postCategoryProduct,
  deleteCategory,
  postCategoryProductsSearch,
  getLegalCategories,
  postGetLegalOptions,
  postCategoryLegal,
  postCategoryLegalSearch,
  getContentCategories,
  postGetContentOptions,
  postCategoryContent,
  postCategoryContentSearch,
};
